// src/pages/PrivacyPage.js
import React from 'react';
import { Shield, Lock, Bell } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold text-center mb-8">מדיניות פרטיות</h1>
      
      <div className="bg-white rounded-lg shadow-lg p-6 space-y-8">
        {/* הקדמה */}
        <section>
          <p className="text-gray-600 mb-4">
            משרד עורכי דין מיכלסון מכבד את פרטיותכם ומחויב להגן על המידע האישי שלכם. 
            מדיניות זו מתארת כיצד אנו אוספים, משתמשים ומגנים על המידע שלכם.
          </p>
        </section>

        {/* אבטחת מידע */}
        <section className="space-y-4">
          <div className="flex items-start gap-4">
            <Shield className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-xl font-bold mb-2">אבטחת מידע</h2>
              <p className="text-gray-600">
                אנו מחויבים להבטיח את אבטחת המידע האישי שלכם. האתר עושה שימוש בטכנולוגיות אבטחה מתקדמות, 
                כולל תעודת SSL, כדי להצפין את המידע המועבר בינינו לבין המשתמשים ולמנוע גישה לא מורשית.
                כל הנתונים המוזנים בטפסים באתר (כגון פרטי קשר או מידע רגיש אחר) מועברים באופן מאובטח באמצעות פרוטוקול HTTPS.
              </p>
            </div>
          </div>
        </section>

        {/* איסוף מידע */}
        <section className="space-y-4">
          <div className="flex items-start gap-4">
            <Lock className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-xl font-bold mb-2">איסוף ושימוש במידע</h2>
              <p className="text-gray-600">
                אנו אוספים מידע שאתם מספקים לנו באופן ישיר, כגון:
              </p>
              <ul className="list-disc list-inside mr-6 mt-2 text-gray-600 space-y-1">
                <li>שם מלא</li>
                <li>פרטי קשר (טלפון, דוא"ל)</li>
                <li>מידע הקשור לפנייתכם המשפטית</li>
              </ul>
              <p className="mt-4 text-gray-600">
                המידע משמש אותנו ליצירת קשר עמכם, מתן שירות משפטי ושיפור השירותים שלנו.
              </p>
            </div>
          </div>
        </section>

        {/* עדכון ופרצות */}
        <section className="space-y-4">
          <div className="flex items-start gap-4">
            <Bell className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-xl font-bold mb-2">עדכון והודעות</h2>
              <p className="text-gray-600">
                במקרה של חשש לפרצת אבטחה או שימוש לרעה במידע, ננקוט בפעולות הנדרשות על פי חוק, 
                וניידע את המשתמשים בהתאם להוראות הדין. אתם רשאים לבקש בכל עת מידע על הנתונים שנאספו לגביכם, 
                או לבקש את מחיקתם.
              </p>
            </div>
          </div>
        </section>

        {/* יצירת קשר */}
        <section className="mt-8 pt-8 border-t">
          <p className="text-gray-600">
            לכל שאלה או בירור בנושא מדיניות הפרטיות, ניתן ליצור איתנו קשר דרך 
            <a href="/contact" className="text-blue-600 hover:text-blue-800 mx-1">עמוד יצירת הקשר</a>
            שלנו.
          </p>
        </section>

        {/* עדכון אחרון */}
        <div className="text-sm text-gray-500 mt-8">
          עודכן לאחרונה: ינואר 2024
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;